module.exports = __webpack_public_path__ + "img/DSC_1828.4d174def.JPG";